module.exports = __webpack_public_path__ + "82a01c16da3cd87fedc80c2df518b782.png";